(() => {
  if (window.almilaCuratedProducts) {
    window.almilaCuratedProducts.initializeAll();
    return;
  }
  const instances = new WeakMap();
  function initialize(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-almila-curated-track]');
    const controls = root.querySelector('[data-almila-curated-controls]');
    const previous = root.querySelector('[data-almila-curated-prev]');
    const next = root.querySelector('[data-almila-curated-next]');
    if (!track || !controls || !previous || !next) return;
    const abort = new AbortController();
    const options = {signal: abort.signal};
    let frame;
    function update() {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      controls.hidden = maximum < 2;
      const atStart = track.scrollLeft < 2;
      const atEnd = track.scrollLeft >= maximum - 2;
      // A focused arrow that becomes disabled would drop keyboard focus to the page: hand it to the other arrow.
      if (atStart && !atEnd && document.activeElement === previous) next.focus({preventScroll: true});
      if (atEnd && !atStart && document.activeElement === next) previous.focus({preventScroll: true});
      previous.disabled = atStart;
      next.disabled = atEnd;
    }
    function scheduleUpdate() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }
    function move(direction) {
      const cards = track.querySelectorAll('[data-almila-curated-card]');
      if (!cards.length) return;
      const stride = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].getBoundingClientRect().width;
      // One step is the cards in view (4 on desktop, 3 on tablets, 2 on phones): card by card it took eight clicks to see twelve.
      const inView = Math.max(1, Math.round(track.clientWidth / stride));
      track.scrollBy({left: direction * stride * inView, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('scroll', scheduleUpdate, {...options, passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant'});
      }
    }, options);
    const resize = new ResizeObserver(scheduleUpdate);
    resize.observe(track);
    instances.set(root, () => {abort.abort(); resize.disconnect(); cancelAnimationFrame(frame); instances.delete(root);});
    update();
  }
  function roots(container, selector = '[data-almila-curated-products]') {
    return [...(container.matches?.(selector) ? [container] : []), ...container.querySelectorAll(selector)];
  }
  function initializeAll(container = document) {
    roots(container).forEach(initialize);
  }
  window.almilaCuratedProducts = {initializeAll};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), {once: true});
  else initializeAll();
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    roots(event.target).forEach(root => instances.get(root)?.());
  });
})();
